import React from 'react';
import { connect } from 'react-redux';
import AboutDashboard from './AboutDashboardComponent/AboutDashboard';


const AboutIndex = (props) => {
    return (
        <AboutDashboard {...props} />
    )
}
const mapStateToProps = state => ({
    state: state,

});
const mapDispatchToProps = dispatch => {
    return {
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(
    AboutIndex
);